/**
 * The parts of Sitecore's `LinkFieldValue` this reads, spelled out rather than picked from
 * `@sitecore-jss`, so the published `@Eneco/cms` declarations do not need that package.
 */
interface LinkFieldValueParts {
  anchor?: string;
  href?: string;
  querystring?: string;
}

// Takes a LinkFieldValue object and combines the href, anchor, and querystring properties into a single string while
// adding a leading ? and # to the querystring and anchor as needed.
export const getCombinedLinkFieldValueHref = (link: LinkFieldValueParts): string => {
  if (!link) return '';

  const querystring = link.querystring ? `?${link.querystring.replace(/^\?/, '')}` : '';
  const anchor = link.anchor ? `#${link.anchor.replace(/^#/, '')}` : '';

  return `${link.href ?? ''}${querystring}${anchor}`;
};
